import React, {useCallback, useState} from "react";

import {getArrayFromMap} from '../../../../common/utils/index';
import {LLBurgerIcon} from "../../index";


export const RulesMobileMenu = (
    {
        menuItems,
        activeArticleId,
        setActiveArticleId,
    }
) => {
    const [isOpen, setOpen] = useState(false);
    const [currentPath, setCurrentPath] = useState([]);

    const currentLevel = useCallback(() => {
        if (currentPath.length) {
            let level = menuItems;
            currentPath.forEach((id) => {
                level = level.get(id).children;
            });
            return getArrayFromMap(level);
        } else {
            return getArrayFromMap(menuItems);
        }
    }, [currentPath]);

    return <>
        <div className="rules__menu-header">
            <p
                className="rules__menu-header-arrow"
                onClick={() => {
                    setCurrentPath((v) => {
                        v.pop();
                        return [...v];
                    })
                }}
            >
                {currentPath.length ? <i className="doruk-mg-arrow-2"/> : null}
            </p>
            <LLBurgerIcon
                open={isOpen}
                onClick={() => {
                    setOpen(v => !v);
                    setCurrentPath([]);
                }}
                customClasses="ll-widgets__nav-burger"
            />
        </div>
        <div className="rules__menu-items">
            {isOpen && currentLevel().map(menuItem => <div
                className={`rules__menu-item${activeArticleId === menuItem.article_id ? ' rules__menu-item--active' : ''}`}
                key={menuItem.id}
                onClick={() => {
                    if (menuItem.children.size) {
                        setCurrentPath((v) => [...v, menuItem.id]);
                    } else {
                        setOpen(false);
                        setCurrentPath([]);
                        setActiveArticleId(menuItem.article_id);
                    }
                }}
                                                      >
                <p className="rules__menu-item-label">
                    {menuItem.title}
                </p>
            </div>)}
        </div>
    </>
};